import "./language-switcher.scss"

import React from "react"
import { useTranslation } from "react-i18next"

import { SUPPORTED_LOCALES } from "./config"

// Endonyms are deliberately NOT translated — "Español" reads the same whatever
// language the rest of the page is in. Matches the mobile apps' selector.
//
// The flag lives only inside the <option> text: a closed <select> renders its
// selected option, so a separate flag element next to it renders the emoji
// twice. The visible label is screen-reader-only because the flag and endonym
// already say what the control is.
const LanguageSwitcher = ({ className = "" }) => {
  const { t, i18n } = useTranslation("common")
  const current =
    SUPPORTED_LOCALES.find(locale => locale.code === i18n.resolvedLanguage) || SUPPORTED_LOCALES[0]

  return (
    <label className={`language-switcher ${className}`.trim()}>
      <span className="language-switcher-label">{t("language")}</span>
      <span className="language-switcher-control">
        <select
          value={current.code}
          onChange={event => i18n.changeLanguage(event.target.value)}
        >
          {SUPPORTED_LOCALES.map(locale => (
            <option key={locale.code} value={locale.code}>
              {locale.flag} {locale.label}
            </option>
          ))}
        </select>
      </span>
    </label>
  )
}

export default LanguageSwitcher
